<template>
  <div class="plan-summary">
    <!-- TODO: Kamil - change conditional based on real values and populate summary with them -->
    <div
      v-if="
        !accountStore.account?.plan?.plan_name ||
        (!futureTransfer && !transactionsLoading)
      "
      class="no-plan"
    >
      <div
        class="title opacity-70 fw500"
        v-html="textsStore.account.general.box_1.no_plan_title"
      ></div>
      <p
        class="text opacity-60"
        v-html="textsStore.account.general.box_1.no_plan_text"
      ></p>
    </div>
    <div v-else class="summary">
      <div class="top">
        <div class="tag">
          {{ accountStore.account?.plan?.plan_name }}
        </div>
        <span class="fz18 fw500 opacity-70"
          >{{ accountStore.account?.plan?.total_feeds }} price feeds</span
        >
      </div>
      <div class="summary-row">
        <div class="fw500 opacity-70">Next bill:</div>
        <div v-if="futureTransfer" class="next-bill">
          <span class="opacity-50">
            {{
              formatPrice(
                accountStore.payment?.AgreementSignedUp?.agreementAmount,
                0
              )
            }}
          </span>
          <img
            :src="
              getTokenIconUrl(
                accountStore.payment?.AgreementSignedUp?.paymentTokenSymbol
              )
            "
            width="18"
            height="18"
          />
          <span class="opacity-50">
            on
            {{ new Date(futureTransfer?.billDate * 1000).toLocaleDateString() }}
          </span>
        </div>
        <div v-else-if="transactionsLoading" class="next-bill">
          <DeployerUiGradientLoadingAnimation />
        </div>
      </div>
      <div class="summary-row">
        <div class="fw500 opacity-70">Payment:</div>
        <div class="icon-label">
          <span class="opacity-50">{{
            shortenAddress(accountStore.payment?.AgreementSignedUp?.refId)
          }}</span>
        </div>
      </div>
      <DeployerAccountTeamInitials :show-add="true" />
    </div>
  </div>
</template>

<script setup>
const accountStore = useAccountStore()
const textsStore = useTextsStore()

const transactions = ref([])

const futureTransfer = computed(() => {
  return transactions.value.find(
    (transaction) => transaction.billDate > Math.round(Date.now() / 1000)
  )
})

const transactionsLoading = ref(false)

const fetchTransfers = async (wallet) => {
  if (!wallet) console.error('No wallet provided')

  transactionsLoading.value = true
  const response = await $fetch('/api/get-transfers', {
    method: 'POST',
    body: {
      wallet,
      networkId: accountStore.payment?.AgreementSignedUp?.networkId
    }
  })

  if (!response) {
    console.error('Error while fetching transactions:', response)
  } else {
    transactions.value = response
  }

  transactionsLoading.value = false
}

onMounted(async () => {
  if (accountStore.payment?.AgreementSignedUp?.refId) {
    // console.log(accountStore.payment?.AgreementSignedUp?.refId)

    await fetchTransfers(accountStore.payment?.AgreementSignedUp?.refId)
  }
})

watch(
  () => accountStore.payment?.AgreementSignedUp?.refId,
  async (address) => {
    if (address) {
      await fetchTransfers(address)
    }
  }
)
</script>

<style lang="scss" scoped>
.plan-summary {
  border-radius: 10px;
  border: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
  background: var(--Box-bg, rgba(255, 255, 255, 0));
  max-width: 468px;
  min-height: 130px;
  margin-bottom: 20px;
  padding: 20px;
}

.summary {
  .top {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }
  .tag {
    font-weight: 500;
    line-height: 100%;
    font-size: 1.8rem;
    padding: 5px;
    border-radius: 5px;
    display: inline-block;
    background: #e1dcff;
    color: #654cff;
  }

  :deep(.people) {
    margin-top: 20px;
  }
}

.summary-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;

  :deep(div:first-child) {
    min-width: 70px;
  }

  @media (max-width: 400px) {
    flex-direction: column;
    gap: 5px;
  }
}

.next-bill {
  display: flex;
  gap: 5px;
  min-width: 150px;
  position: relative;
}
</style>
